import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";

import MainStore from "../home/store/mainStore";
import { EbendoDailyProductionBase } from "./ebendo/EbendoDailyProductionBase";
import { NaocDailyProduction } from "./naoc/NaocDailyProduction";
import { QuaiboBaseView } from "./quaibo/QuaiboBaseView";
const mainstore = createContext(MainStore);
export const FieldDailyProductionBaseView = observer(
  ({ data: { permission } }) => {
    console.log("from base", permission);
    const mainStore = useContext(mainstore);
    switch (mainStore.assetContextId) {
      case 1:
        return <NaocDailyProduction permission={permission} />;
      case 2:
        return <EbendoDailyProductionBase permission={permission} />;
      case 3:
        return <QuaiboBaseView permission={permission} />;
      default:
        return <NaocDailyProduction permission={permission} />;
    }
  }
);

